
import { TabContent } from '@launchpad/components/pages/Project/ui/ProjectContent';
import { tableOfContentTab } from '@launchpad/data/projects/wisdomise/data';

import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';

export const wisdomise: ProjectContentData = {
  id: 'wisdomise',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.CONTENT,
      content: <TabContent items={tableOfContentTab} />,
    },
  ],
  hideTabs: true,
};
